import React from "react";

export default function DistributorOverview(){
  return(
  <section classname="font-eudoxus text-black-900 bg-black flex items-centre pl-16 pr-16">
    <h1>Abhi Ready nhi HAI</h1>
  </section>
  );
}
